// Libelles et helpers d'affichage des echeances.
//
// Cette table est un REPLI, pas la reference : le catalogue fait autorite cote
// serveur (GET /echeances/types, voir recurrences.CATALOGUE). Elle sert a
// afficher immediatement, avant que le catalogue soit charge, et a nommer une
// echeance d'un type retire du catalogue mais encore en historique.
const TYPES = {
  controle_technique: "Contrôle technique",
  vgp_hayon: "VGP hayon",
  assurance: "Assurance",
  chronotachygraphe: "Chronotachygraphe — vérification",
  telechargement_donnees: "Téléchargement des données",
};

const STATUTS = {
  a_venir: "À venir",
  en_retard: "En retard",
  effectue: "Effectué",
  // Date DEDUITE de la premiere circulation, faute de connaitre la vraie.
  // Le libelle dit ce qu'on attend de l'utilisateur, pas ce que le systeme a
  // calcule : « Date a renseigner » se corrige, « En retard » affole pour rien.
  a_renseigner: "Date à renseigner",
};

export function labelTypeRecurrence(valeur) {
  return TYPES[valeur] || valeur;
}

export function labelStatutRecurrence(valeur) {
  return STATUTS[valeur] || valeur;
}

// `rec` en second argument, et non le seul nombre de jours : « en retard de
// 7702 j » sur une date deduite est un chiffre faux affiche avec aplomb.
export function texteJoursRestants(jours, rec) {
  if (rec && rec.statut === "a_renseigner") return "À renseigner";
  if (jours === null || jours === undefined) return "—";
  if (jours < 0) return `En retard de ${Math.abs(jours)} j`;
  if (jours === 0) return "Aujourd'hui";
  return `Dans ${jours} j`;
}

// Classe CSS d'urgence : retard (accent fort), rappel J-30 (accent leger).
export function classeUrgence(rec) {
  // Une date inconnue n'est pas une urgence. La teinter en rouge remettrait
  // par la couleur le mensonge que le statut vient d'enlever.
  if (rec.statut === "a_renseigner") return "";
  if (rec.statut === "en_retard") return "urgence-retard";
  if (rec.statut === "a_venir" && rec.jours_restants !== null && rec.jours_restants <= 30) {
    return "urgence-rappel";
  }
  return "";
}
